import { useState } from 'react';
import { Button } from '../../components/Button';
import { INSTRUCTIONS_MEET } from '../../constants/instructions';
import { createPortal } from 'react-dom';

export function MeetInstruction() {
  const [isShowInstruction, setIsShowInstruction] = useState(() => {
    const stored = localStorage.getItem('showed-meet-instruction-modal-1');
    return stored !== null ? JSON.parse(stored) : true;
  });

  return (
    <>
      <button onClick={() => setIsShowInstruction((prev) => !prev)}>
        <img src="/icons/Button-instruction.svg" className="w-[44px] h-[44px] cursor-pointer" />
      </button>
      {isShowInstruction &&
        createPortal(
          <div
            className={`z-[9999] fixed inset-0 flex flex-col bg-black/70 backdrop-blur-[10px]`}
            style={{
              touchAction: 'pan-y',
              paddingTop: 'calc(var(--tg-content-safe-area-inset-top, 0px) * 1.7)'
            }}
          >
            <div
              className="flex-1 overflow-y-auto flex justify-start items-center flex-col pb-[140px]"
              style={{
                overscrollBehavior: 'contain',
                WebkitOverflowScrolling: 'touch' // для старых iOS WebView
              }}
            >
              <h1 className="font-raleway font-bold text-white text-[26px]">Инструкция</h1>
              <h1 className="font-raleway font-light mt-2 text-white text-center text-[18px]">
                Основные функции и жесты
              </h1>
              <div className="grid grid-cols-1 justify-center flex-wrap items-center gap-[16px] w-full mt-[16px] px-4">
                {INSTRUCTIONS_MEET.map((ins, index) => (
                  <div
                    key={ins.id}
                    className={`w-full pt-[10px] pb-[10px] gap-[12px] border-b ${
                      index === INSTRUCTIONS_MEET.length - 1 ? 'border-none' : 'border-[#6D6D6D]'
                    } flex text-white`}
                  >
                    <div className="h-[89px] flex justify-center items-center shrink-0">
                      <img src={ins.svg} className="w-[40px] h-[40px]" alt={ins.title} />
                    </div>
                    <div className={`flex flex-col gap-[4px]`}>
                      <span className={` text-[18px] font-semibold`}>{ins.title}</span>
                      <span className={` text-[14px] font-light`}>{ins.description}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="fixed bottom-[40px] left-0 right-0 flex justify-center z-[10000] pointer-events-none">
              <div className="pointer-events-auto">
                <Button
                  onClick={() => {
                    localStorage.setItem('showed-meet-instruction-modal-1', JSON.stringify(false));
                    setIsShowInstruction(false);
                  }}
                >
                  Понятно
                </Button>
              </div>
            </div>
          </div>,
          document.getElementById('portal')
        )}
    </>
  );
}
